import { useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { flushGpsQueueToServer, checkShiftTimeout, resumeShiftTracking } from '../services/shiftTrackingService';

/**
 * Hook para monitorear el estado de jornada en la aplicación y sincronizar
 * la cola de puntos GPS pendientes cuando hay red.
 * REGLA DE NEGOCIO: Estar autenticado NO activa el tracking por sí solo.
 */
export function useGpsTracking() {
    const { status, user } = useAuth();

    useEffect(() => {
        if (status !== 'authenticated' || !user) {
            return;
        }

        const resume = () => {
            checkShiftTimeout();
            void resumeShiftTracking();
            void flushGpsQueueToServer().catch((error) => console.warn('[GPS] Sincronización pendiente:', error));
        };
        const onVisibility = () => { if (document.visibilityState === 'visible') resume(); };
        resume();
        document.addEventListener('visibilitychange', onVisibility);
        window.addEventListener('online', resume);
        const listener = Capacitor.isNativePlatform()
            ? App.addListener('appStateChange', ({ isActive }) => { if (isActive) resume(); })
            : null;

        return () => {
            document.removeEventListener('visibilitychange', onVisibility);
            window.removeEventListener('online', resume);
            if (listener) void listener.then((handle) => handle.remove()).catch(() => {});
        };
    }, [status, user?.id]);
}
